import { NgModule, ModuleWithProviders } from '@angular/core';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

declare var ga: any;

@Injectable()
export class AnalyticsService {
    public pageTrack(path: string): void {
        if(environment.production === true) {
            ga('send', 'pageview', path);
        }
    }
    public eventTrack(action: string, category: string): void {
        if(environment.production === true) {
            ga('send', 'event', {
                eventCategory: category,
                eventAction: action
            });
        }
    }
}

@NgModule({})
export class AnalyticsModule {
    static forRoot(config: any): ModuleWithProviders {
        if(environment.production === true) {
            if(!config.key || config.key === '') {
                throw new Error('You must provide an Analytics Key to track views.');
            }
            AnalyticsModule.addGAElement(config.key);
        }
        return {
            ngModule: AnalyticsModule
        };
    }
    static addGAElement(key: string): void {
        let el = document.createElement("script");
        el.innerHTML = "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');ga('create', '"+key+"', 'auto');";
        document.head.appendChild(el);
    }
}



// WEBPACK FOOTER //
// ./src/app/analytic.service.ts